import { createErrorList } from 'Cloud/Application/ErrorList';

export const ALBUMS_FOLDER_NAME = 'Альбомы';

export const albumErrors = createErrorList({
    name_too_long: 'Превышено количество символов в названии файла',
    required: 'Название не может быть пустым',
    unknown: 'Ошибка на сервере',
    create_error: 'Не удалось создать альбом',
    add_error: 'Не удалось добавить медиа в альбом',
});
